import { useQuery } from "@tanstack/react-query";
import { bakedSuiteManifest, fetchSuiteManifest } from "@/lib/suite/suiteManifest";

/** The Help Genie app family, from /apps.json with a baked fallback. */
export const useSuiteManifest = () =>
  useQuery({
    queryKey: ["suite-manifest"],
    queryFn: fetchSuiteManifest,
    staleTime: 5 * 60 * 1000,
    placeholderData: bakedSuiteManifest,
  });
